import {
  SET_AI_HEATMAP_DATA,
  SET_AI_SCORES_DATA,
  SET_AI_HEATMAP_DATA_SOURCE,
  SET_AI_PRODUCT_HEATMAP_DATA,
  HEATMAP_STATE,
} from '../constants/ActionTypes';

export const setAiHeatmapDataSource = data => ({
  type: SET_AI_HEATMAP_DATA_SOURCE,
  data,
});

export const setAiHeatmapData = data => ({
  type: SET_AI_HEATMAP_DATA,
  data,
});

export const setAiScoresData = data => ({
  type: SET_AI_SCORES_DATA,
  data,
});

export const setAiProductHeatmapData = data => ({
  type: SET_AI_PRODUCT_HEATMAP_DATA,
  data,
});

export const clearHeatmapInfo = data => ({
  type: HEATMAP_STATE,
  data,
});
